module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"auditsTitle":"Latest Backups","alert":{"create":"Success! Automatic backups are now configured.","terminate":"Your automatic backups were terminated. It is recommended that you set up a new one as soon as possible."}}}')
  delete Component.options._Ctor
}
